import { type Dispatch, type SetStateAction } from 'react';
import {
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import type { INotification } from '../models/Notification';

interface MessageModalProps {
  unreadMessages: INotification[];
  setUnreadMessages: Dispatch<SetStateAction<INotification[]>>;
  setIsReadNotification: (notification: INotification, isRead: boolean) => void;
  openButtonLocalization: string;
  closeButtonLocalization: string;
}

const MessageModal: React.FC<MessageModalProps> = (props) => {
  const show = props.unreadMessages.length > 0;
  const currentMessage = props.unreadMessages[0];

  const handleClose = () => {
    if (currentMessage) {
      const updatedMessages = props.unreadMessages.filter((m) => m.Id !== currentMessage.Id);
      props.setUnreadMessages(updatedMessages);
      props.setIsReadNotification(currentMessage, true);
    }
  };

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const targetUrl = currentMessage?.OpenLink || currentMessage?.RelatedUrl;
    if (!targetUrl) return;

    handleClose();
    window.location.assign(targetUrl);
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            boxShadow: `0 24px 64px ${alpha('#0f172a', 0.16)}, 0 8px 24px ${alpha('#0f172a', 0.08)}`,
          },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>{currentMessage?.Title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="body2"
            color="text.primary"
            sx={{
              '& *': {
                color: 'inherit !important',
              },
            }}
          >
            {currentMessage?.SubTitle}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          {props.closeButtonLocalization}
        </Button>
        {currentMessage?.IsOpenShown && (
          <Button
            href={currentMessage.OpenLink || currentMessage.RelatedUrl || undefined}
            onClick={handleOpen}
            variant="contained"
            color="primary"
          >
            {props.openButtonLocalization}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MessageModal;
